export default __webpack_public_path__ + "static/aarogyaSeva-0d8c71dcfff0386176aa60244aa99810.jpg";